import CartPopUpItem from './cart-popup-item';
import CloseIcon from '@/components/ui/icons/close-icon';
import { useTranslations } from 'next-intl';
import CartTitle from './cart-title';
import { useRef } from 'react';
import useHandleOutside from '@/hooks/useHandleOutside';
import NextLink from '@/components/next-link';

const CartPopUpWrapper = ({ togglePopup, cartItems, total }) => {
  const t = useTranslations('cart');
  const ref = useRef();

  useHandleOutside(ref, () => togglePopup());

  return (
    <section className='z-modal bg-opacity-60 fixed start-0 top-0 z-5000 h-screen w-screen bg-black/60'>
      <div ref={ref} className='max-h-screen min-h-screen max-w-80 min-w-80'>
        <div className='gray-scroll-bar flex max-h-screen min-h-screen max-w-80 min-w-80 flex-col gap-2 overflow-y-auto bg-white p-2 sm:max-w-100 sm:min-w-100 lg:max-w-[600px] lg:min-w-[600px] lg:gap-5 lg:p-4'>
          <div className='flex items-center justify-between'>
            <h1 className='text-xl uppercase max-lg:text-lg max-md:text-base max-sm:text-sm lg:font-bold'>
              {t('successfully_added_to_cart')}
            </h1>
            <CloseIcon
              onClick={() => togglePopup()}
              className='size-5 cursor-pointer lg:size-8'
            />
          </div>
          {cartItems?.length > 0 && (
            <div
              className={`blue-scroll-bar flex max-h-[60vh] flex-col gap-2.5 overflow-y-auto`}
            >
              {cartItems?.map((product, index) => (
                <CartPopUpItem
                  info={product}
                  togglePopup={togglePopup}
                  key={index}
                />
              ))}
            </div>
          )}
          <CartTitle total={total} />
          {/* <Image
            loading='lazy'
            src='https://placehold.jp/b8b9c7/ffffff/500x318.png'
            className='h-auto w-full object-contain'
            alt='Cart Bannr Img !'
          /> */}
          {/* {Info?.related?.length > 0 ? (
            <CartPopupSlider products={Info?.related || []} />
          ) : null} */}
        </div>
        <div className='sticky bottom-0 z-50 max-w-80 min-w-80 sm:max-w-100 sm:min-w-100 lg:max-w-[600px] lg:min-w-[600px]'>
          <div className='grid grid-cols-2 gap-5 bg-white px-4 py-2 sm:gap-3'>
            <NextLink
              href='/cart'
              onClick={() => togglePopup()}
              className='bg-primary block w-full rounded-md py-1 text-center text-lg text-white max-lg:text-[15px] max-md:text-sm'
            >
              {t('go_to_cart_key')}
            </NextLink>
            <button
              onClick={() => togglePopup()}
              className='border-border block w-full rounded-md border py-1 text-center text-lg max-lg:text-[15px] max-md:text-sm'
            >
              {t('continue_shopping_key')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CartPopUpWrapper;
